export default __webpack_public_path__ + "static/skater-fe14caf2919b3b9a9adb000bb0786f0b.gif";